import type { Dispatch, SetStateAction } from "react";
import { t } from "@/i18n-js/instance";
import { ContentFilterDropdown } from "@/react/components/shared/ContentFilterDropDown";

const i18nRoot = "settings.emails.templates";

export type ContentType = "all" | "visual" | "text";

export const TemplateFilter = ({
  selectedContentType,
  setSelectedContentType,
}: {
  selectedContentType: ContentType;
  setSelectedContentType: Dispatch<SetStateAction<ContentType>>;
}) => {
  const OPTIONS: { label: string; value: ContentType }[] = [
    {
      label: t([i18nRoot, "all"]),
      value: "all",
    },
    {
      label: t([i18nRoot, "visual"]),
      value: "visual",
    },
    {
      label: t([i18nRoot, "text"]),
      value: "text",
    },
  ];

  return (
    <ContentFilterDropdown
      selectedTemplateType={selectedContentType}
      setSelectedTemplateType={setSelectedContentType}
      options={OPTIONS}
      translationKey={i18nRoot}
    />
  );
};
